// SSE store for /SSE/AgentReconnect — broadcasts "your phone has a pending
// IVR call, please reconnect" events from the backend skill-route queue.
// Mirrors the lifecycle of userInfoStore.js (open on first subscriber, close
// on last, automatic retry on error).

let subscribers = new Set(); // (event) => void
let eventSource = null;
let retryCount = 0;
const MAX_RETRIES = 5;

const buildSseUrl = () => {
  let url = process.env.REACT_APP_IP + '/SSE/AgentReconnect';
  try {
    const { getToken } = require('./auth');
    const token = getToken();
    if (token) url += '?token=' + encodeURIComponent(token);
  } catch (e) { /* auth not available */ }
  return url;
};

const broadcast = (event) => {
  subscribers.forEach((cb) => {
    try { cb(event); } catch (e) { console.log('agentReconnect subscriber error:', e); }
  });
};

const connect = () => {
  if (!localStorage.getItem('roles')) return;
  if (eventSource) { eventSource.close(); eventSource = null; }
  try {
    eventSource = new EventSource(buildSseUrl());
    eventSource.addEventListener('agentreconnect', (e) => {
      try {
        const data = JSON.parse(e.data);
        retryCount = 0;
        broadcast(data);
      } catch (err) { console.log('SSE agentreconnect parse error:', err); }
    });
    eventSource.onopen = () => { retryCount = 0; };
    eventSource.onerror = () => {
      try { eventSource.close(); } catch (e) {}
      eventSource = null;
      retryCount++;
      if (retryCount <= MAX_RETRIES && subscribers.size > 0) {
        setTimeout(connect, 3000 * Math.min(retryCount, 5));
      }
    };
  } catch (e) {
    console.log('agentReconnect SSE not supported:', e);
  }
};

const disconnect = () => {
  if (eventSource) { try { eventSource.close(); } catch (e) {} eventSource = null; }
  retryCount = 0;
};

export const subscribeAgentReconnect = (cb) => {
  subscribers.add(cb);
  if (subscribers.size === 1) connect();
  return () => {
    subscribers.delete(cb);
    if (subscribers.size === 0) disconnect();
  };
};
